export default {
  Sony: 'msg_codes_accountType_sony',
};
